export default __webpack_public_path__ + "static/media/background_reports_blue_advocates.9449ff03.png";